import { createContext, use } from 'react';

/**
 * Açılır içeriğin katmanı (08 §5.4: dropdown 20 · sheet 30 · dialog 40). Select, Popover, açılır menü ve araç ipucu
 * body'ye taşınır (portal) ve sayfada `z-dropdown` katmanındadır. Sheet ya da Dialog içinden açılınca o yüzeyin hemen
 * üstünde çizilir: yoksa panelin altında kalır, görünmez ve tıklama panelin örtüsüne gider (ör. "Ekran bağla"daki
 * lokasyon listesi). Yüzey React ağacıyla taşınır; portal bağlamı koparmaz.
 */
export type Surface = 'page' | 'sheet' | 'dialog';

/** Sheet ve Dialog içeriğini sarar: içindeki açılır içerik o yüzeyin katmanını alır. */
export const SurfaceContext = createContext<Surface>('page');

const floatingLayer: Record<Surface, string> = {
  page: 'z-dropdown',
  sheet: 'z-dropdown-sheet',
  dialog: 'z-dropdown-dialog',
};

/** Açılır içeriğin z-index sınıfı: bulunduğu yüzeyin hemen üstü. */
export function useFloatingLayer(): string {
  return floatingLayer[use(SurfaceContext)];
}
